<div class='wrapperStartEndDate'>
  <field text='Start Date'>
    <selectDate #startDateRef placeholder='MM / DD / YYYY' (emit)='valueChangeDate($event,"startDate")' [disabled]="disabled"></selectDate>
  </field>
  <field text='End Date'>
    <selectDate #endDateRef placeholder='MM / DD / YYYY' (emit)='valueChangeDate($event,"endDate")' [disabled]="disabled"></selectDate>
  </field>
</div>